// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4d67af05","289":"c54536b0","362":"8c8c3456","453":"8701dc61","461":"05ae4c06","783":"02f391aa","806":"77c7e86b","997":"3840f8d2"}[chunkId] + ".chunk.js";
};